<div class="tool-bar">
  <div class="current-date">
    <span style="font-size: 115%">
    Route Optimizer
    </span>
  </div>
  <!--  <div class="space-block">-->
  <!--  </div>-->
  <div class="next-week-period">
    <span style="font-size: 115%">
      Activities Planner
    </span>
  </div>
</div>
<div class="middle-content" *ngIf="!vehiclesLoading" cdkDropListGroup>
  <div class="route-optimizer">
    <div class="activities-block">
      <div class="activities-label">
        {{currentDate}}
      </div>
      <div class="available-activities-list" cdkDropList [cdkDropListData]="todayActivities"

           (cdkDropListDropped)="vehicleRouteDropped($event)">
        <app-activity-route cdkDrag (cdkDragStarted)="dndStart()"
                            (cdkDragEnded)="dndEnd()" [activity]="activity" class="project-activity"
                            *ngFor="let activity of todayActivities" [ngClass]="{'activity-ready': activity.ready}">
        </app-activity-route>
      </div>
    </div>
    <div class="vehicles-block">
      <div class="vehicles-block-scroll">
        <div class="vehicle-card" *ngFor="let vehicle of routeVehicles; let i = index">
          <div class="vehicle-status" [style.background-color]="'#'+vehicle.status?.color"
               [style.border-color]="'#'+vehicle.status?.color">
            {{vehicle.status?.title}}
          </div>
          <div class="vehicle-header" matRipple (click)="editVehicle(vehicle, i)">
            <div class="vehicle-header-left">
              <div class="vehicle-name">
                {{vehicle.name}}
              </div>
              <div class="vehicle-user">
                {{vehicle.user ? vehicle.user.name : 'No User'}}
              </div>
            </div>
            <div class="vehicle-header-right" *ngIf="vehicle.totalDuration > 0">
              Total {{getDuration(vehicle.totalDuration)}}
            </div>
          </div>
          <ng-container *ngIf="vehicle.status.name === 'Available'">
            <div class="vehicle-projects vehicle-index-{{i}}" cdkDropList [cdkDropListData]="vehicle.activities"

                 (cdkDropListDropped)="vehicleRouteDropped($event, vehicle)">
              <app-activity-route cdkDrag [activity]="activity" class="project-activity" (cdkDragStarted)="dndStart()"
                                  (cdkDragEnded)="dndEnd()"
                                  *ngFor="let activity of vehicle.activities"
                                  [ngClass]="{'activity-ready': activity.ready}" [inVehicle]="true">
              </app-activity-route>
            </div>
          </ng-container>
          <ng-container *ngIf="vehicle.status.name !== 'Available'">
            <div class="vehicle-projects">
              <app-activity-route [activity]="activity" class="project-activity" [inVehicle]="true"
                                  *ngFor="let activity of vehicle.activities"
                                  [ngClass]="{'activity-ready': activity.ready}">
              </app-activity-route>
            </div>
          </ng-container>
          <div class="tool-footer">
            <button mat-button (click)="optimizeRoute(vehicle)"
                    [ngClass]="{'disabled-button': optimizeId === vehicle.id}"
                    [disabled]="optimizeId === vehicle.id"
                    *ngIf="vehicle.status.name === 'Available' && !vehicle.routeOptimized && vehicle.activities.length">
              <span *ngIf="optimizeId !== vehicle.id">Reoptimize</span>
              <lib-mini-progress-spinner *ngIf="optimizeId === vehicle.id"></lib-mini-progress-spinner>
            </button>

            <div class="space-block"></div>
            <button mat-button (click)="openLink(vehicle)"
                    [ngClass]="{'disabled-button': !vehicle.routeUrl || linkId === vehicle.id}"
                    [disabled]="!vehicle.routeUrl || linkId === vehicle.id">
              <span *ngIf="linkId !== vehicle.id">Link</span>
              <lib-mini-progress-spinner *ngIf="linkId === vehicle.id"></lib-mini-progress-spinner>
            </button>

            <button mat-button (click)="sendSMS(vehicle)" *ngIf="vehicle.status.name !== 'Available'"
                    [ngClass]="{'disabled-button': smsId === vehicle.id || !vehicle.user}"
                    [disabled]="smsId === vehicle.id || !vehicle.user">
              <span *ngIf="smsId !== vehicle.id">Send SMS</span>
              <lib-mini-progress-spinner *ngIf="smsId === vehicle.id"></lib-mini-progress-spinner>
            </button>

            <button class="approve-button" mat-button (click)="approveVehicle(vehicle)"
                    *ngIf="vehicle.status.name === 'Available'">Approve
            </button>
            <button class="approve-button" mat-button (click)="driveOut(vehicle)"
                    *ngIf="vehicle.status.name === 'Approved'">Drive Out
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="activities-planning">
    <app-logistic-planning-week></app-logistic-planning-week>
  </div>
</div>

<div class="middle-content" *ngIf="vehiclesLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
